export enum ChatType {
  chat = "chat",
  muc = "muc",
  entity_conversation = "entity_conversation",
}
